import { jsxs, jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { createPortal } from "react-dom";
const ImagePreviewOverlay = ({ src, alt, onClose }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);
  return createPortal(
    /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: onClose,
        style: {
          position: "fixed",
          inset: 0,
          zIndex: 1e4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "lab(0% 0 0 / 0.9)"
        },
        children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: onClose,
              style: {
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                padding: "8px",
                lineHeight: 0
              },
              "aria-label": "Close preview",
              children: /* @__PURE__ */ jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [
                /* @__PURE__ */ jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
                /* @__PURE__ */ jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
              ] })
            }
          ),
          /* @__PURE__ */ jsx(
            "img",
            {
              src,
              alt: alt || "Preview",
              onClick: (e) => e.stopPropagation(),
              style: {
                maxWidth: "90vw",
                maxHeight: "90vh",
                objectFit: "contain",
                borderRadius: "8px",
                cursor: "default"
              }
            }
          )
        ]
      }
    ),
    document.body
  );
};
export {
  ImagePreviewOverlay
};
//# sourceMappingURL=ImagePreviewOverlay.js.map
